import React from 'react';
import {
  Box,
  Chip,
  Grid,
  Typography,
  Divider
} from '@mui/material';
import PropTypes from 'prop-types';

const FormFieldGroup = ({ 
  label,
  chipColor = "default",
  chipSize = "small",
  children,
  showDivider = false,
  dividerText,
  spacing = 3,
  ...gridProps
}) => {
  return (
    <Box>
      {/* Optional Divider */}
      {showDivider && (
        <Box sx={{ my: 2 }}>
          {dividerText ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Divider sx={{ flex: 1 }} />
              <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2 }}>
                {dividerText}
              </Typography>
              <Divider sx={{ flex: 1 }} />
            </Box>
          ) : (
            <Divider />
          )}
        </Box>
      )}

      {/* Chip Label */}
      {label && (
        <Box sx={{ mb: 1 }}>
          <Chip 
            label={label} 
            color={chipColor} 
            size={chipSize}
          />
        </Box>
      )}

      {/* Spacer when no label but children need alignment */}
      {!label && children && React.Children.count(children) > 1 && (
        <Box sx={{ height: 24, mb: 1 }} />
      )}

      {/* Grid Container for Fields */}
      <Grid container spacing={spacing} {...gridProps}>
        {children}
      </Grid>
    </Box>
  );
};

const FormFieldItem = ({ children, xs = 12, sm, md, lg, xl, ...gridProps }) => {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} {...gridProps}>
      {children}
    </Grid>
  );
};

FormFieldGroup.propTypes = {
  label: PropTypes.string,
  chipColor: PropTypes.oneOf([
    'default', 
    'primary', 
    'secondary', 
    'success', 
    'error', 
    'warning', 
    'info'
  ]),
  chipSize: PropTypes.oneOf(['small', 'medium']),
  children: PropTypes.node.isRequired,
  showDivider: PropTypes.bool,
  dividerText: PropTypes.string,
  spacing: PropTypes.number,
};

FormFieldItem.propTypes = {
  children: PropTypes.node.isRequired,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
};

export { FormFieldGroup, FormFieldItem }; 